import React from 'react';
import styled from 'styled-components';
import aboutme from '../img/about_me.jpg';

function ImageSection() {
  return (
    <ImageSectionStyled>
      <div className="left-content">
        <img src={aboutme} alt="" />
      </div>
      <div className="right-content">
        <h4>
          I am <span>Pedro Gonçalves</span>
        </h4>
        <p className="paragraph">
          My name is Pedro Alexandre Grou Gonçalves, I was born in 11 of October 1993. I'm from Portugal, and I live in
          Castelo Branco, where I'm taking my bachelor degree in the Instituto Politécnico de Castelo Branco, in
          Computer Engineering I also like to play the guitar and listen to music as hobbys.
        </p>
        <div className="about-info">
          <div className="info-title">
            <p>Full Name</p>
            <p>Age</p>
            <p>Nationality </p>
            <p>Languages </p>
            <p>Location</p>
          </div>
          <div className="info">
            <p>: Pedro Alexandre Grou Gonçalves</p>
            <p>: 29</p>
            <p>: Portuguese </p>
            <p>: Portuguese, English, Spanish, French </p>
            <p>: Castelo Branco, Portugal</p>
          </div>
        </div>
        <a
          href="https://drive.google.com/file/d/1dN1PtQ-cTisDiFEddF6jCfAYoLe8jgCQ/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
        >
          <p>Download CV</p>
        </a>
      </div>
    </ImageSectionStyled>
  );
}

const ImageSectionStyled = styled.div`
  margin-top: 5rem;
  display: flex;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    .left-content {
      margin-bottom: 2rem;
    }
  }

  .left-content {
    width: 100%;

    img {
      width: 95%;
      object-fit: cover;
      height: 74vh;
      border-radius: 10px;
    }
  }
  .right-content {
    width: 100%;
    a {
      background-color: var(--background-dark-color);
      padding: 0.8rem 2.5rem;
      color: var(--font-light-color);
      cursor: pointer;
      display: inline-block;
      font-size: inherit;
      text-transform: uppercase;
      position: relative;
      transition: all 0.4s ease-in-out;
      border-radius: 50px;
      border: 2px solid var(--border-color);
      &:hover {
        border: 2px solid var(--primary-color);
        border-radius: 50px;
      }
    }
    h4 {
      font-size: 2rem;
      color: var(--white-color);
      span {
        font-size: 2rem;
      }
    }
    .paragraph {
      padding: 1rem 0;
    }
    .about-info {
      display: flex;
      padding-bottom: 1.4rem;
      .info-title {
        padding-right: 3rem;
        p {
          font-weight: 600;
        }
      }
      .info-title,
      .info {
        p {
          padding: 0.3rem 0;
        }
      }
    }
  }
`;
export default ImageSection;
